import { IRepresentativesProfile } from 'shared/interfaces/IRepresentatives';
import {
  EditProfileSideInfoActions,
  EditProfileSideInfoActionsButton,
  EditProfileSideInfoContainer,
} from './EditProfileSideInfo.styles';
import { CircularProgress, Hidden } from '@material-ui/core';
import { AgencyPermissionEnums } from 'shared/enums/AgencyPermissionEnums';
import { Fragment, lazy, memo, Suspense, useCallback, useState } from 'react';
import { useRepresentativesModal } from 'pages/Representatives/context/RepresentativesModalProvider';
import { useEditProfileDelete } from '../../hooks/useEditProfileDelete';
import RepresentativesListItem from 'pages/Representatives/features/RepresentativesList/components/RepresentativesListItem/RepresentativesListItem';
import EditProfileSideInfoLargeView from './EditProfileSideInfoLargeView/EditProfileSideInfoLargeView';
import PublicProfile from 'pages/PublicProfile/PublicProfile';
const EditProfileSideInfoModalLazy = lazy(() => import('../EditProfileSideInfoModal/EditProfileSideInfoModal'));

type EditProfileSideInfoProps = {
  data: IRepresentativesProfile;
  handleAction: (value: AgencyPermissionEnums, callback: VoidFunction) => void;
};

const EditProfileSideInfo = ({ data, handleAction }: EditProfileSideInfoProps) => {
  const { handleOpen, handleSetMessage } = useRepresentativesModal();

  const { handleDeleteRepresentative, isDeleting, ConfirmationModal, handleDeleteConfirmation, isOpen } =
    useEditProfileDelete(data?.id, data?.primary || false, (title: string, message: string) => {
      handleSetMessage(title, message, 'Close');
      handleOpen();
    });

  const [openDialog, setOpenDialog] = useState<boolean>(false);

  const handleDialog = useCallback(() => {
    setOpenDialog((prev) => !prev);
  }, []);

  const handlePrimaryImageUpload = useCallback(() => {
    handleAction(AgencyPermissionEnums.PRIMARY_IMAGE_SELECTION, () => {
      handleDialog();
    });
  }, []);

  const [openRepresentatives, setOpenRepresentatives] = useState<boolean>(false);

  const handleOpenRepresentatives = useCallback(() => {
    setOpenRepresentatives((prev) => !prev);
  }, []);

  return (
    <Fragment>
      {isOpen ? <ConfirmationModal onConfirm={handleDeleteRepresentative} /> : null}
      <EditProfileSideInfoContainer>
        <Hidden lgUp>
          {/* Mobile View Details Info */}
          <RepresentativesListItem
            profile={data}
            handlePrimaryChange={() => {}}
            primaryTagDisable={false}
            primaryTagLoading={false}
            removeTag
            handlePrimaryImageUpload={handlePrimaryImageUpload}
          />
        </Hidden>
        <Hidden mdDown>
          {/* Large View Details Info */}
          <EditProfileSideInfoLargeView data={data} handlePrimaryImageUpload={handlePrimaryImageUpload} />
        </Hidden>
        <EditProfileSideInfoActions>
          <EditProfileSideInfoActionsButton variant="contained" onClick={handleOpenRepresentatives}>
            View Representative
          </EditProfileSideInfoActionsButton>
          <EditProfileSideInfoActionsButton
            variant="contained"
            className="edit-profile-delete"
            onClick={handleDeleteConfirmation}
            disabled={isDeleting}
          >
            {isDeleting ? <CircularProgress size={16} /> : ' Delete Representative'}
          </EditProfileSideInfoActionsButton>
        </EditProfileSideInfoActions>
      </EditProfileSideInfoContainer>
      {openDialog ? (
        <Suspense fallback="">
          <EditProfileSideInfoModalLazy open={openDialog} handleOpen={handleDialog} />
        </Suspense>
      ) : null}
      {openRepresentatives ? (
        <PublicProfile
          viewProfile={openRepresentatives}
          profileId={data?.id}
          onClose={handleOpenRepresentatives}
          shareableProfileErrorCallback={() => {
            handleSetMessage('Representative Error', 'Public profile is not availabe for now', 'Close');
            handleOpen();
            handleOpenRepresentatives();
          }}
        />
      ) : null}
    </Fragment>
  );
};

export default memo(EditProfileSideInfo);
